import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import styles from "../../prepare-invoice/styles/prepareInvoice.module.scss";
import { Box, Button, FormControl, Grid } from "@mui/material";
import { useFormUpdatePassword } from "../hook/useFormUpdatePassword";
import { useUserManagement } from "../hook/useUserManagement";
import { Spinner } from "shared";
import { fieldsFormPassword } from "../helper/fieldsFormPassword";
import { columnsUsersType } from "../types/columsUsers.types";

interface FormUpdateUsersProps {
  user: columnsUsersType;
}

export const FormUpdatePassword = ({ user }: FormUpdateUsersProps) => {
  const {
    formikRef,
    initialValues,
    isLoading,
    handleSubmit,
    validationSchema,
  } = useFormUpdatePassword(user);
  const { onCloseModal } = useUserManagement();
  const [dataFields, setDataFields] = useState<any[]>([]);

  useEffect(() => {
    const passwordFields = fieldsFormPassword();
    setDataFields(passwordFields);
  }, []);

  return (
    <>
      <div className={styles.container}>
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          onSubmit={(values) => handleSubmit(values)}
          validationSchema={validationSchema}
          enableReinitialize={true}
          validateOnBlur={true}
          validateOnChange={true}
        >
          {(formik) => (
            <Form
              className={styles.formPrepareInvoice}
              data-testid="form-invoice"
            >
              <Grid container>
                {dataFields.map((fieldData, i) => (
                  <Grid item xs={12} md={6} key={i}>
                    <FormControl fullWidth className={styles.itemForm}>
                      <label
                        htmlFor={fieldData.id}
                        className={`${fieldData.required ? "text-required" : "label-form-required"}`}
                      >
                        {fieldData.label}{" "}
                      </label>
                      <Field
                        id={fieldData.id}
                        placeholder={fieldData.placeholder}
                        type={fieldData.type}
                        variant="outlined"
                        name={fieldData.name}
                        maxLength={fieldData.maxLength}
                        className={
                          formik.touched[fieldData.name] &&
                          Object.keys(formik.errors).includes(fieldData.name)
                            ? styles.errorCampo
                            : ""
                        }
                        data-testid={fieldData.id}
                      />
                      <Box display="flex" justifyContent="space-between">
                        <span
                          className={styles.spanError}
                          data-testid={`${fieldData.id}-error`}
                        >
                          {fieldData.required &&
                            Object.keys(formik.errors).includes(
                              fieldData.name,
                            ) &&
                            formik.touched[fieldData.name] &&
                            formik.errors[fieldData.name]}
                        </span>
                        <span className={styles.spanCounter}>
                          {formik?.values?.[fieldData.name]?.toString()
                            .length || 0}
                          /{fieldData.maxLength}
                        </span>
                      </Box>
                    </FormControl>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <div className={styles.containerButtons}>
                    <Button
                      className={styles.buttonCancel}
                      onClick={onCloseModal}
                      data-testid="button-cancel"
                    >
                      {"Cancelar"}
                    </Button>
                    <Button
                      type="submit"
                      data-testid="button-submit"
                      variant="contained"
                      className={styles.buttonSubmit}
                    >
                      Guardar
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
      {isLoading && <Spinner />}
    </>
  );
};
